import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import fetch from '@costar/costar-fetch';
import urljoin from 'url-join';

function fetchContactCardInfo(_x) {
  return _fetchContactCardInfo.apply(this, arguments);
}
function _fetchContactCardInfo() {
  _fetchContactCardInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    var apiBasePath, setContactCardData, request, url, result;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apiBasePath = params.apiBasePath, setContactCardData = params.setContactCardData, request = params.request;
          url = urljoin(apiBasePath, '/shared-api/training-contacts');
          _context.prev = 2;
          _context.next = 5;
          return fetch.post(url, {
            body: JSON.stringify(request),
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 5:
          result = _context.sent;
          setContactCardData({
            data: result,
            isFetching: false
          });
          _context.next = 13;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          console.error({
            msg: 'Fetch contact card info failed',
            error: _context.t0
          });
          setContactCardData({
            error: _context.t0,
            isFetching: false
          });
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9]]);
  }));
  return _fetchContactCardInfo.apply(this, arguments);
}

export { fetchContactCardInfo as default };
//# sourceMappingURL=fetch-contact-card-info.esm.js.map
